module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1050-1048f22527e5550ed51438ca8c6f9d66.png";